import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpinnerContainerHorizontal, SpinnerContainerCentered } from "./Spinner.styles";
import CircularProgress from "@mui/material/CircularProgress";
import { colors } from "healthex-common/colors";
export function spinner() {
    return _jsx(SpinnerContainerCentered, { children: basicSpinner() });
}
export function basicSpinner(spinnerSize = 40) {
    return (_jsx(CircularProgress, { className: "loadingButtonCircularProgress", size: spinnerSize, sx: {
            color: colors.black_lighter,
        } }));
}
export function spinnerHorizontal(loadingText, spinnerSize = 40) {
    return (_jsxs(SpinnerContainerHorizontal, { children: [basicSpinner(spinnerSize), loadingText] }));
}
